"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lazyLoad;

function lazyLoad(props) {
  var O = {};
  Object.keys(props).forEach(function (i) {
    Object.defineProperty(O, i, {
      enumerable: true,
      configurable: true,
      get: function get() {
        delete O[i];
        var src,
            target = 'default';
        if (typeof props[i] == 'string') src = props[i];else {
          src = props[i].src;
          target = props[i].target;
        }
        O[i] = require(src)[target || 'default'];
        return O[i];
      },
      set: function set(v) {
        delete O[i];
        O[i] = v;
      }
    });
  });
  return O;
}